import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    byProjectId: {},
};

const projectHealthStatusSlice = createSlice({
    name: "projectHealthStatus",

    initialState,

    reducers: {
        setProjectHealthStatus: (state, action) => {
            const { projectId, healthStatus } = action.payload;

            if (!projectId) {
                return;
            }

            state.byProjectId[String(projectId)] = {
                ...healthStatus,
            };
        },

        setLastReviewDate: (state, action) => {
            const { projectId, date } = action.payload;

            if (!projectId) {
                return;
            }

            const key = String(projectId);

            if (!state.byProjectId[key]) {
                state.byProjectId[key] = {};
            }

            state.byProjectId[key].lastReviewDate =
                date || null;
        },

        clearProjectHealthStatus: (state, action) => {
            const projectId = action.payload;

            if (!projectId) {
                return;
            }

            delete state.byProjectId[String(projectId)];
        },

        clearAllProjectHealthStatus: (state) => {
            state.byProjectId = {};
        },
    },
});

export const {
    setProjectHealthStatus,
    setLastReviewDate,
    clearProjectHealthStatus,
    clearAllProjectHealthStatus,
} = projectHealthStatusSlice.actions;

// ─── Selectors ──────────────────────────────────────────────────────────────

export const selectProjectHealthStatus = (
    state,
    projectId
) => {
    if (!projectId) {
        return null;
    }

    return (
        state.projectHealthStatus?.byProjectId?.[
            String(projectId)
        ] ?? null
    );
};

export const selectLastReviewDate = (
    state,
    projectId
) => {
    if (!projectId) {
        return null;
    }

    return (
        state.projectHealthStatus?.byProjectId?.[
            String(projectId)
        ]?.lastReviewDate ?? null
    );
};

export default projectHealthStatusSlice.reducer;